import { render, staticRenderFns } from "./Search2.vue?vue&type=template&id=8564c0c0"
import script from "./Search2.vue?vue&type=script&lang=js"
export * from "./Search2.vue?vue&type=script&lang=js"
import style0 from "./Search2.vue?vue&type=style&index=0&id=8564c0c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports